import { useState } from "react";
import { Slider } from "../components/Slider";
import { useDispatch, useSelector } from "react-redux";

export const ParameterSliderRange = ({ parameterHandlers, sideEffect, orientation, size, label, labelSize="12px", noLabel=false, noOutput=false, style={}, ...props }) => {
    [activeThumbIndex, setActiveThumbIndex] = useState(0);

    const numericMinValue = Math.min(...parameterHandlers.map(handler=>handler.getNumericMin()));
    const numericMaxValue = Math.max(...parameterHandlers.map(handler=>handler.getNumericMax()));
    
    if (orientation==='vertical') style.height = size || '80px';
    if (orientation==='horizontal') style.width = size || '200px';

    const dispatch = useDispatch();
    const onNewValues = (newValues, parameterHandlers, oldValues) => {
        const isReversed = newValues[0] > newValues[1];
        if (isReversed) newValues = newValues.toReversed(); // ensures the first value is always the minimum
        parameterHandlers.forEach((handler, index) => {
            const newValue = handler.num2Real(newValues[index]);
            const oldValue = oldValues[index];
            if (newValue === oldValue) return; // No need to dispatch if the value hasn't changed
            dispatch(handler.updater(newValue))
        });
        sideEffect && sideEffect();
    }
    function resetToDefaults() {
        parameterHandlers.forEach(handler => {
            dispatch(handler.updater(handler.getDefaultValue()));
        })
        sideEffect && sideEffect();
    }
    const realValues = parameterHandlers.map(parameterHandler => useSelector(parameterHandler.selector));
    return (
        <Slider
            {...props}
            style={style}
            orientation={orientation}
            value={realValues.map((realValue, index) => parameterHandlers[index].real2Num(realValue))}
            step={parameterHandlers[0].getStep() || 0.001 }
            min={numericMinValue}
            max={numericMaxValue}
            onNewValue={onNewValues}
            label={label || parameterHandlers[0].description.label}
            output={parameterHandlers[activeThumbIndex].real2String(realValues[activeThumbIndex])}
            noLabel={noLabel} noOutput={noOutput}
            colorRange
            isRange={true}
            throttleDeps={[parameterHandlers]} // otherwise in the sampler we won't get different controls for pads
            onDoubleClick={resetToDefaults}
        />
    )
};